import { ConfigurationContext } from '@news-mono/web-common'
import React from 'react'
import { withRouter } from 'react-router-dom'
import { StyledContent } from './AmpStyledContent.styled'

export const AmpSurveyMonkey: React.ComponentClass<{}> = withRouter((props) => (
    <ConfigurationContext.Consumer>
        {(config) => (
            <StyledContent>
                <a
                    href={`https://${
                        config.publicHostname
                    }${props.location.pathname.replace('.amp', '')}`}
                >
                    To vote on the survey, please view on our full website
                </a>
            </StyledContent>
        )}
    </ConfigurationContext.Consumer>
))
